module.exports = __webpack_public_path__ + "images/boatyard_logo_pettit.fcaefb20f6ee0160ce01505da99cfc99.png";